/**
 * Utility functions for navigation
 */

/**
 * Stores the current page URL in sessionStorage before navigating to the login page.
 * This allows redirecting back to the original page after successful login.
 *
 * @param currentPath - The current path to store
 */
export const storePreviousPageBeforeLogin = (currentPath: string): void => {
  // Don't store login, auth, or reset-password pages as the previous page
  // Also don't store the homepage (/) to prevent redirect loops
  if (
    currentPath !== "/" &&
    currentPath !== "/login" &&
    currentPath !== "/auth" &&
    !currentPath.startsWith("/reset-password")
  ) {
    if (process.env.NODE_ENV === "development") {
      console.log(`[Navigation] Storing previous page: ${currentPath}`);
    }
    sessionStorage.setItem("previousPage", currentPath);
  } else if (process.env.NODE_ENV === "development") {
    console.log(`[Navigation] Not storing excluded page: ${currentPath}`);
  }
};

/**
 * Gets the stored previous page URL from sessionStorage.
 *
 * @returns The stored previous page URL or '/' if none exists
 */
export const getPreviousPage = (): string => {
  const previousPage = sessionStorage.getItem("previousPage");
  if (process.env.NODE_ENV === "development") {
    console.log(`[Navigation] Retrieved previous page: ${previousPage || "/"}`);
  }
  return previousPage || "/";
};

/**
 * Clears the stored previous page URL from sessionStorage.
 */
export const clearPreviousPage = (): void => {
  if (process.env.NODE_ENV === "development") {
    console.log(`[Navigation] Clearing previous page storage`);
  }
  sessionStorage.removeItem("previousPage");
};
